import type { RouteRecord } from 'vite-react-ssg';
import { Layout } from './Layout';
import {
  Home,
  Products,
  Portfolio,
  Services,
  About,
  Contact,
  NotFound,
  AppDetail,
  ClientDetail,
  Terra,
  Substrate,
} from './components/pages';
import { AdminLogin, AdminDashboard, TerraAccessAdmin, ProtectedRoute } from './components/pages/admin';
import { apps } from './data/apps';
import { clients } from './data/clients';
import './styles/global.css';

export const routes: RouteRecord[] = [
  {
    path: '/',
    Component: Layout,
    children: [
      { index: true, Component: Home },
      { path: 'products', Component: Products },
      { path: 'products/substrate', Component: Substrate },
      {
        path: 'products/:appId',
        Component: AppDetail,
        getStaticPaths: () =>
          apps.filter(a => a.id !== 'substrate').map(a => `products/${a.id}`),
      },
      { path: 'portfolio', Component: Portfolio },
      {
        path: 'portfolio/:clientId',
        Component: ClientDetail,
        getStaticPaths: () => clients.map(c => `portfolio/${c.id}`),
      },
      { path: 'services', Component: Services },
      { path: 'about', Component: About },
      { path: 'contact', Component: Contact },
      { path: 'terra', Component: Terra },
      { path: 'admin/login', Component: AdminLogin },
      {
        path: 'admin',
        element: (
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/terra',
        element: (
          <ProtectedRoute>
            <TerraAccessAdmin />
          </ProtectedRoute>
        ),
      },
      { path: '*', Component: NotFound },
    ],
  },
];
